import { Icon } from '@/lib/icons';
import type { CollectionPlaceCopy } from '../collection-place.contract';

type GeolocationConsentPanelProps = {
  copy: CollectionPlaceCopy;
  isSaving: boolean;
  onAnswer: (decision: 'granted' | 'denied') => void;
};

/** Asked once per account: why, what for, what is kept (spec 004). */
export function GeolocationConsentPanel({ copy, isSaving, onAnswer }: GeolocationConsentPanelProps) {
  return (
    <section
      aria-labelledby="geolocation-consent-title"
      data-testid="geolocation-consent"
      className="space-y-3 rounded-2xl border border-primary/25 bg-primary/[0.05] p-4"
    >
      <div className="flex items-start gap-3">
        <Icon name="mapPin" className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
        <h3 id="geolocation-consent-title" className="text-sm font-semibold text-foreground">
          {copy.consentTitle}
        </h3>
      </div>
      <ul className="space-y-1.5 pl-7 text-sm leading-6 text-muted-foreground">
        <li>{copy.consentWhy}</li>
        <li>{copy.consentWhat}</li>
        <li className="font-medium text-foreground/85">{copy.consentKept}</li>
      </ul>
      <p className="pl-7 text-xs leading-5 text-muted-foreground/80">{copy.consentChoice}</p>
      <div className="flex flex-col gap-2 pl-7 sm:flex-row">
        <button
          type="button"
          disabled={isSaving}
          onClick={() => onAnswer('granted')}
          className="rounded-full border border-primary/35 bg-primary/10 px-4 py-2 text-sm font-semibold text-primary transition-colors hover:bg-primary/15 disabled:opacity-50"
        >
          {isSaving ? copy.saving : copy.accept}
        </button>
        <button
          type="button"
          disabled={isSaving}
          onClick={() => onAnswer('denied')}
          className="rounded-full border border-border/45 px-4 py-2 text-sm font-semibold text-muted-foreground transition-colors hover:text-foreground disabled:opacity-50"
        >
          {copy.decline}
        </button>
      </div>
    </section>
  );
}
